import { render, staticRenderFns } from "./DialogEditInventory.vue?vue&type=template&id=4a8dac36&"
import script from "./DialogEditInventory.vue?vue&type=script&lang=js&"
export * from "./DialogEditInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports